/**
 * The schools' masters who recruit for them.
 */
import { LOOKS, heroBase } from './heroes';
import { BLOOD_ROBE, JILEGU_ROBE, JUNZITANG_ROBE } from './uniforms';

LOOKS.bloodMaster = {
  school: 'cinnabar',
  ...heroBase,
  ...BLOOD_ROBE,
  faceStyle: 'refCold',
  iris: '#8a1a22',
  brow: '#120a0a',
  poseFaces: { atk: 'refShout', block: 'refGrit', cast: 'refGrit' },
  hair: '#1a0a0c',
  hairH: '#4a1a20',
  hairStyle: 'loose',
  headwear: 'band',
  accent: '#c8202a',
  beard: 'stubble',
  pauldron: { c: '#2a0a0e', s: '#c8202a' },
};
LOOKS.blissLady = {
  school: 'dim-moon',
  ...LOOKS.lilac!,
  ...JILEGU_ROBE,
  faceStyle: 'refSmirk',
  iris: '#b03a80',
  hair: '#1a1020',
  hairH: '#4a2a50',
  hairStyle: 'loose',
  headwear: 'pin',
  crown: '#e86aa8',
  crownS: '#b04a80',
  weapon: 'none',
};
LOOKS.scholar = {
  school: 'pine-ink',
  ...heroBase,
  ...JUNZITANG_ROBE,
  faceStyle: 'refSerious',
  iris: '#2a3a4a',
  brow: '#1a1a20',
  poseFaces: { atk: 'refShout', block: 'refGrit', cast: 'refGrit' },
  hair: '#1a1a22',
  hairH: '#3a4a5a',
  hairStyle: 'topknot',
  headwear: 'pin',
  crown: '#3a6a9a',
  crownS: '#28507a',
  wlen: 21,
};
